import React from 'react'
import STATES from '../../states'
import { SelectInput } from '../../../../components/form-components/inputs.component.jsx'
import StyledFlexContainer from './../../../../components/containers/flex-container.component'
import CityService from '../../../../services/city.service'

const stateOptions = STATES.map(({ Nome, Sigla }) => ({
	value: Sigla,
	label: Nome
}))

export default class AddressFields extends React.PureComponent {
	constructor(props) {
		super(props)
		this.onStateChange = onStateChange.bind(this)
		this.onCityChange = onCityChange.bind(this)
		this.previousSelectedState = ''
		this.state = {
			cityOptions: []
		}
	}

	render() {
		return (
			<StyledFlexContainer>
				<SelectInput
					id="state"
					className="col-4"
					label="UF *"
					placeholder="Selecione ..."
					onValueChange={this.onStateChange}
					options={stateOptions}
					multi={false}
					{...this.props}
				/>
				<SelectInput
					id="city"
					className="col-8"
					label="Cidade *"
					placeholder="Selecione ..."
					onValueChange={this.onCityChange}
					options={this.state.cityOptions}
					multi={false}
					{...this.props}
				/>
			</StyledFlexContainer>
		)
	}
}

function onStateChange(value) {
	if (value == this.previousSelectedState) return

	this.previousSelectedState = value
	this.currentState = value
	this.props.setFieldValue('city', '')

	CityService.search({ state: this.currentState }).then(({ data }) => {
		const cityOptions =
			(data &&
				data.map(value => ({
					label: value,
					value
				}))) ||
			[]
		this.setState({ cityOptions })
	})
}

function onCityChange(value) {}
